// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","main":"App_main__3ZkGI","footer":"App_footer__29Fsv","title":"App_title__-GfWs"};